<template>
<keep-alive>
    <div class="accountrecorder" name="accountrecorder">
      <topNav :title="title"></topNav>
    
      <div class="cell_container" v-if="!showRecord">
        <div class="cell_item" @click="handleSwhRecord('paymentRecords')">
          <h5>扫码支付开票</h5>
          <p>微信/支付宝扫码支付</p>
          <van-icon class="extra" name="arrow" />
        </div>
        <div class="cell_item" @click="handleSwhRecord('electronicInvoice')">
          <h5>其他支付开票</h5>
          <p>现金/ETC/第三方支付/付款码支付</p>
          <van-icon class="extra" name="arrow" />
        </div>
      </div>
      
    </div>
</keep-alive>

</template>
<script>
import Vue from 'vue'
import topNav from "../topnav/topnav"
import {DETAIL as API} from "@/assets/api"
import { Card, Loading, Icon } from 'vant';

export default {
  name: 'paymentRecords',
  components:{
     topNav,
     [Card.name]: Card,
     [Loading.name]: Loading,
     [Icon.name]: Icon,
  },
  data() {
    return {
      title:"开票类型",
    }
  },
  methods:{
    handleSwhRecord(type){
      this.$router.push({ name: type })
    },
  },
  created(){
    
  },
  destroyed(){
    
  },
}
</script>
<style lang="less" scoped>
  .van_card{
    background-color: #fff;
  }
  .van_cell{
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
    }
  }
  .cell_container{
    padding: 20px 12px 0 12px;
    .cell_item{
      background-color: #fff;
      border-radius: 5px;
      padding: 16px;
      margin: 0 auto;
      margin-bottom: 20px;
      text-align: left;
      position: relative;
      h5{
        font-weight: bold;
        font-size: 16px;
        line-height: 1.5;
        color: #333;
      }
      p{
        font-size: 14px;
        line-height: 1.5;
        color: #999;
      }
      &:last-child{
        margin-bottom: 0;
      }
      .extra{
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/my/recordType.vue